import React, { Component } from 'react';
import { connect } from 'react-redux';
import Slider from "react-slick";
import axios from 'axios';
import Loader from 'react-loader-spinner';
import Layout from '../layout/Layout';
import Callusnow from './Callusnow';
import { Redirect, Link, withRouter } from 'react-router-dom';
import $ from 'jquery';  

const API_URL = process.env.REACT_APP_API_URL;
var fs = require('browserify-fs');
class Home extends Component {
	
	constructor(props) {
        super(props);
 
        this.state = {
          	loaded: true,
            slider: [],
			home:[],
			Ourreach:[],
			Volunteeringworks:[],
			Workingtogether:[],
			Aboutourfoundation:[],
			OurImpact:[],
			Visionandmission:[],
			Volunteer:[],
			languagedata:[],
			defaultlang:6,
			fields:{},
    		errors: {}
        };
		const deflang= localStorage.getItem('DefaultLanguage');
        if(deflang == null){
           localStorage.setItem('DefaultLanguage',6);
        }
       
        this.handleSubmit=this.handleSubmit.bind(this);
        this.handleChangeContact=this.handleChangeContact.bind(this);


    }







handleChangeContact(e) {

     let fields = this.state.fields;
      fields[e.target.name] = e.target.value;
      this.setState({
        fields
      });


}

validateForm() {

      let fields = this.state.fields;
      let errors = {};
      let formIsValid = true;

      if (!fields["name"]) {
        formIsValid = false;
        errors["name"] = "Please enter full name.";
      }

      if (typeof fields["name"] !== "undefined") {
        if (!fields["name"].match(/^[a-zA-Z ]*$/)) {
          formIsValid = false;
          errors["name"] = "Please enter alphabet characters only.";
        }
      }
	  
	  
	  if (!fields["email"]) {
        formIsValid = false;
        errors["email"] = "Please enter email-ID.";
      }

      if (typeof fields["email"] !== "undefined") {
        //regular expression for email validation
        var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
        if (!pattern.test(fields["email"])) {
          formIsValid = false;
          errors["email"] = "Please enter valid email-ID.";
        }
      }
	  
	  
	   if (!fields["phone"]) {
        formIsValid = false;
        errors["phone"] = "Please enter phone no.";
      }

      if (typeof fields["phone"] !== "undefined") {
        if (!fields["phone"].match(/^[0-9]{10}$/)) {
          formIsValid = false;
          errors["phone"] = "Enter valid phone no.";
        }
      }
	  
	  
	   if (!fields["amount"]) {
        formIsValid = false;
        errors["amount"] = "Enter helping amount.";
      }

      if (typeof fields["amount"] !== "undefined") {
        if (!fields["amount"].match(/^\-?([0-9]+(\.[0-9]+)?|Infinity)$/)) {
          formIsValid = false;
          errors["amount"] = "Enter numbers only.";
        }
      }
	  
	  
	  
	  

      this.setState({
        errors: errors
      });
      return formIsValid;


    }

handleSubmit(e) {
e.preventDefault();
if(this.validateForm()){	
var full_name=this.state.fields.name;
var email=this.state.fields.email;
var phone=this.state.fields.phone;
var country=this.state.fields.country;
var amount=this.state.fields.amount;
this.props.history.push("/Donate?full_name="+full_name+"&email="+email+"&phone="+phone+"&amount="+amount);

}
}  


componentDidMount() {
	
	
    	$('html, body').animate({
		scrollTop:0
		}, 1000);

	

	}

	 componentWillMount() {
    	
	  const deflang= localStorage.getItem('DefaultLanguage');
        if(deflang == null){
           localStorage.setItem('DefaultLanguage',6);
        }
        
  	const DefaultLang = localStorage.getItem('DefaultLanguage');
    this.setState({defaultlang: DefaultLang});
	this.gethomeapi(DefaultLang);
   
    this.ABOUTUS(DefaultLang,'Aboutourfoundation');
    this.Visionandmission(DefaultLang,'Visionandmission');
    this.Ourreach(DefaultLang,'Ourreach');
    this.Volunteeringworks(DefaultLang,'Volunteeringworks');
    this.Workingtogether(DefaultLang,'Workingtogether');

    this.getlanguage(DefaultLang);
    
	}


getlanguage(defaultlang){
    
   
    axios.post(`${API_URL}/langfile`, { LangId:defaultlang})
        
        .then(res => {
       
          if(res.data.Status == 1)
          {
            const language = res.data.ResponseData;
            let data = res.data.ResponseData[0];
           
             const mythis=this;
             this.setState({ language }); 

              this.setState({languagedata: data});
             
           
                     
            
          }
          })
        
        
        
}

gethomeapi(DefaultLang)
{


	this.setState({ loaded: true });
	axios.post(`${API_URL}/home`, { LanguageId:DefaultLang})
			  
			  .then(res => {
				
				if(res.data.Status == 1)
				{
					const home = res.data.ResponseData.Slider;
					const OurImpact = res.data.ResponseData.OurImpact;
					const Volunteer = res.data.ResponseData.Volunteer;
					this.setState({ home });
					this.setState({ OurImpact });
					this.setState({ Volunteer });
					this.setState({ loaded: false });
				
				}else{
					
					this.setState({ home:[] });
					this.setState({ OurImpact:[] });
					this.setState({ Volunteer:[] });
				}
				
			  })
	
}	

ABOUTUS(DefaultLang,type)
{

	axios.post(`${API_URL}/cmsBlockapi`, 
		{
		 LanguageId:DefaultLang,
		 Type:type

		}).then(res => {
				if(res.data.Status == 1)
				{
					const Aboutourfoundation = res.data.ResponseData.Aboutourfoundation;
					this.setState({ Aboutourfoundation });
				}else{
					this.setState({ Aboutourfoundation:[] });
				}
		this.setState({ loaded: false });
				
		})
	
}

Visionandmission(DefaultLang,type)
{

	axios.post(`${API_URL}/cmsBlockapi`, 
		{
		 LanguageId:DefaultLang,
		 Type:type

		}).then(res => {
				if(res.data.Status == 1)
				{
					const Visionandmission = res.data.ResponseData.Visionandmission;
					this.setState({ Visionandmission });
				}else{
					this.setState({ Visionandmission:[] });
				}
		this.setState({ loaded: false });
				
		})
	
}

Ourreach(DefaultLang,type)
{

	axios.post(`${API_URL}/cmsBlockapi`, 
		{
		 LanguageId:DefaultLang,
		 Type:type

		}).then(res => {
				if(res.data.Status == 1)
				{
					const Ourreach = res.data.ResponseData.Ourreach;
					this.setState({ Ourreach });
				}else{
					this.setState({ Ourreach:[] });
				}
		this.setState({ loaded: false });
				
		})
	
}


Volunteeringworks(DefaultLang,type)
{

	axios.post(`${API_URL}/cmsBlockapi`, 
		{
		 LanguageId:DefaultLang,
		 Type:type

		}).then(res => {
				if(res.data.Status == 1)
				{
					const Volunteeringworks = res.data.ResponseData.Volunteeringworks;
					this.setState({ Volunteeringworks });
				}else{
					this.setState({ Volunteeringworks:[] });
				}
		this.setState({ loaded: false });
				
		})
	
}


Workingtogether(DefaultLang,type)
{

	axios.post(`${API_URL}/cmsBlockapi`, 
		{
		 LanguageId:DefaultLang,
		 Type:type

		}).then(res => {
				if(res.data.Status == 1)
				{
					const Workingtogether = res.data.ResponseData.Workingtogether;
					this.setState({ Workingtogether });
				}else{
					this.setState({ Workingtogether:[] });
				}
		this.setState({ loaded: false });
				
		})
	
}







  render() {
	  
	  
	  
	  const options = {
			
		    dots:false,
		    loop: true,
		    autoplay: true,
		    margin:5,
			responsive: {
               0: {
				items: 1,
				nav: true
				},
				600: {
				  items: 3,
				  nav: false
				},
				1000: {
				  items: 6,
				  nav: true
				}
             }
		};

		const settings = {
	      dots: false,
      infinite: true,
      speed: 500,
      slidesToScroll: 6,
      slidesToShow: 6,
      autoplay:true,
	  autoplaySpeed:10000,
      arrows: false,
     responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 6,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
            initialSlide: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]

	     
  		 
	    };
	  
	  const events = {
			onDragged: function(event) { /*console.log('onDragged: ' + event.type);*/ },
			onChanged: function(event) { /*console.log('onChanged: ' + event.type);*/ },
			onTranslate: function(event) { /*console.log('onTranslate: ' + event.type);*/ }
		};
	  
	  
	  
    return (
      <div className="App">
	  <Layout languagedata={this.state.languagedata}>
        
	  {this.state.loaded == true ? (	  
		 
	<div className="divloader"> 
		 <Loader 
			 type="ThreeDots"
			 color="#00BFFF"
			 height="100"	
			 width="100"
		  />		  
	 </div>
	
	) : '' }

	
	  	<section className="banner">
		  <div className="bd-example">
		    <div id="carouselExampleCaptions" className="carousel slide" data-ride="carousel">
		      <ol className="carousel-indicators">
			  {this.state.home.map((item, key) =>
		        
		        <li data-target="#carouselExampleCaptions" data-slide-to={key} className={ key == 0 ? 'active' : '' }></li>
				
			   )};	
			 
		      </ol>
		      <div className="carousel-inner">
		      
			  {this.state.home.map((item, key) =>

			   <div className={key == 0 ? 'carousel-item active' : 'carousel-item' }>
		          <img src={item.SliderImage} className="d-block w-100" alt={"slider - "+item.SliderTitle} />
		          <div className="carousel-caption">
		            <aside>{item.SliderTitle}</aside>
					<p dangerouslySetInnerHTML={{__html: item.SliderDescription}} ></p>
		            <button>{this.state.languagedata.get_support}</button>
					
		          </div>
		        </div>
				
			  )};
		      
		      </div>
		    </div>
		  </div>
		</section>


		<section>
		  <div className="reach">
		    <aside>{this.state.Ourreach.BlockName}</aside>
			<div dangerouslySetInnerHTML={{__html: this.state.Ourreach.BlockDescription}} />
		  </div>
		  
		  <div className="Volunteering">
		    <span>{this.state.Volunteeringworks.BlockName}​</span>
		    <div dangerouslySetInnerHTML={{__html: this.state.Volunteeringworks.BlockDescription}} />
		    <Link to={"/Volunteer#applynow"}>{this.state.languagedata.apply_now}</Link>
		  </div>
		  
		  <div className="reach together">
		    <aside>{this.state.Workingtogether.BlockName}​</aside>
		    <div dangerouslySetInnerHTML={{__html: this.state.Workingtogether.BlockDescription}} />
		  </div>
		  
		  <div className="clearfix"></div>
		</section> 



		<section className="about">
		  <div className="container">
		    <div className="row">
		      <div className="col-xl-8 col-lg-12 col-md-12"> 
		        <h1>{this.state.Aboutourfoundation.BlockName}​</h1>
				 <img src={this.state.Aboutourfoundation.BlockImage} className="d-block d-sm-block d-md-none" alt="About us" />
		        <p dangerouslySetInnerHTML={{__html: this.state.Aboutourfoundation.BlockDescription}} ></p>
		      </div>
		      <div className="col-xl-4 col-lg-12 col-md-12 d-none d-sm-none d-md-block">
		        <img src={this.state.Aboutourfoundation.BlockImage} alt="About us" />
		      </div>
		    </div>
		  </div>
		</section>


		<section className="impact">
		  <h2>{ this.state.languagedata.our_impact}</h2>
		  
		   { this.state.OurImpact.length>0 ? 
		  <Slider {...settings}>
		   
		   { this.state.OurImpact.map((impact, key) => 
			<div className="item">
		      <img src={impact.ImpactImage} alt={impact.ImpactTitle}/>
		    </div>
			
			
			)}
		   </Slider> : "" }
		</section>

		<section className="help">
		  <div className="container">
		    <div className="row">
		      <div className="col-xl-3 col-lg-3 col-md-3">
		        <aside>
		          { this.state.languagedata.need_your} 
		          <span>{ this.state.languagedata.help}</span> 

		        </aside>
		      </div>
		      <div className="col-xl-9 col-lg-9 col-md-9">
		        <ul className="list-unstyled">
		          <li>
		            <label for="name">{this.state.languagedata.Name}* </label>
		          <input type="text" className={this.state.errors.name ? "error_class" : ""}
		          autoComplete="off" placeholder={this.state.errors.name ? this.state.errors.name : "Full Name"} name="name" onChange={this.handleChangeContact}  id="name"/>
		        
		          </li>

		          <li>
		           <label for="email">{this.state.languagedata.Email_Address}* </label>
		           <input type="text" autoComplete="off" className={this.state.errors.email ? "error_class" : ""} placeholder={this.state.errors.email ? this.state.errors.email : "Email"} name="email" id="email"  onChange={this.handleChangeContact} /></li>
		          <li>
		           <label for="phone">
				          {this.state.languagedata.Phone}*</label>
				          <input type="text" autoComplete="off" className={this.state.errors.phone ? "error_class" : ""} placeholder={this.state.errors.phone ? this.state.errors.phone : "Phone"} name="phone" id="phone"  onChange={this.handleChangeContact}/></li>
		        
		          <li>
		           <label for="amount">
				        {this.state.languagedata.Helping_Amount}*</label>
		          <input type="text" autoComplete="off" className={this.state.errors.amount ? "error_class" : ""}  placeholder={this.state.errors.amount ? this.state.errors.amount : "Helping Amount"} name="amount" id="amount" onChange={this.handleChangeContact} /></li>
		          <li><button  onClick={this.handleSubmit} class="donate_btn">{ this.state.languagedata.donate}</button></li>
		        </ul>
		      </div>
		    </div>
		  </div>
		</section>

		<section className="about vision">
		  <div className="container">
		    <div className="row">
		      <div className="col-xl-4 col-lg-4 col-md-12">
		      <img src={this.state.Visionandmission.BlockImage} alt="Vision adminssion" />
		    </div>
		      <div className="col-xl-8 col-lg-8 col-md-12">
		        <h2>{this.state.Visionandmission.BlockName}​</h2>
		        <p dangerouslySetInnerHTML={{__html: this.state.Visionandmission.BlockDescription}} ></p>
		      </div>
		      
		    </div>
		  </div>
		</section>

		<section className="Our_Volunteers">
		  <div className="container">
		    <div className="row">
		      <div className="col-12">
		        <h2>{this.state.languagedata.our_volunteers}</h2>
		      </div>
		    </div>
		    <div className="row">
		    {this.state.Volunteer.map((item) =>
		      <div className="col-xl-4 col-lg-4 col-md-4">
		        <img src={item.VoltImage} alt={"Profile of - "+item.VoltTitle}/>
		        <div className="box">
		          <span>{item.VoltTitle}</span>
		          <p dangerouslySetInnerHTML={{__html: item.VoltDescription}} ></p>
		        </div>
		      </div>
		      )}
		      
		    </div>
		  </div>
		</section>

		<Callusnow languagedata={this.state.languagedata} />
		</Layout>
     
      </div>
    );
  }
}

export default withRouter(Home);



// WEBPACK FOOTER //
// ./src/component/Home.js